<template>
    <div>
        <v-layout justify-end column v-show="$store.state.showVarGame">
            <v-flex xs12>
                <v-layout justify-end>
                    <v-btn type="button" round color="#FF7BA3" class="whiteText" v-on:click="toHome">
                        <v-icon>exit_to_app</v-icon>
                    </v-btn>
                </v-layout>
            </v-flex>
        </v-layout>
        <br>
        <br>
        <br>
        <v-container v-show="$store.state.showVarGame">

            <template>

                <v-card>
                    <v-container>
                        <v-form
                                ref="form"
                                lazy-validation
                        >
                            <v-select
                                    v-model="selectTimeSeconds"
                                    :items="tempsPregunta"
                                    label="Temps pregunta(segons)"
                                    required
                            ></v-select>


                            <v-select
                                    v-model="selectProbability"
                                    :items="probabilitatEncerts"
                                    label="Probabilitat d'encert(%)"
                                    required
                            ></v-select>

                            <br>
                            <br>

                            <v-text-field
                                    v-model="linkEstadistiques"
                                    label="Ruta Estadístiques"
                                    required
                            ></v-text-field>

                            <v-text-field
                                    :rules="passwordAdminRules"
                                    v-model="passwordAdmin"
                                    label="Password Admin"
                                    required
                            ></v-text-field>
                            <v-layout justify-end>
                                <v-btn
                                        color="success"
                                        v-on:click="validate"
                                >
                                    Guardar
                                </v-btn>
                            </v-layout>
                        </v-form>
                    </v-container>
                </v-card>
            </template>
        </v-container>
        {{changeSelecteds}}
    </div>
</template>

<script>

    import VueFire from 'vuefire'
    import Vue from 'vue'
    import 'vuejs-noty/dist/vuejs-noty.css'
    import {db} from '../firebaseConfig'
    import Noty from 'noty';


    let varGame = db.ref('varGame');

    Vue.use(VueFire);

    export default {
        name: "VarGame",
        data() {
            return {
                valid: false,
                selectTimeSeconds: null,
                tempsPregunta: [5, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 140],
                selectProbability: null,
                probabilitatEncerts: [10,20,30,40,50,60,70,80,90,100],
                passwordAdmin: null,
                linkEstadistiques: null,
                passwordAdminRules: [
                    v => !!v || ''
                ]
            }
        },
        methods: {
            created() {

            },
            validate () {
                if (this.$refs.form.validate()) {
                    this.saveChanges()
                } else {
                    new Noty({
                        layout: 'topCenter',
                        type: 'error',
                        text: "Introduiex els camps obligatoris",
                        timeout: 2000
                    }).show();
                }
            },
            toHome() {
                if (this.$refs.form.validate()) {
                    this.$store.commit('showAdminHomeTrue');
                    this.$store.commit('showVarGameFalse');
                } else {
                    new Noty({
                        layout: 'topCenter',
                        type: 'error',
                        text: "Introduiex els camps obligatoris",
                        timeout: 2000
                    }).show();
                }
            },
            saveChanges () {
                varGame.child('timeSeconds').set(this.selectTimeSeconds);
                varGame.child('probability').set(this.selectProbability);
                varGame.child('passwordAdmin').set(this.passwordAdmin);
                varGame.child('linkEstadistiques').set(this.linkEstadistiques);

                new Noty({
                    layout: 'topCenter',
                    type: 'warning',
                    text: "Guardat!",
                    timeout: 2000
                }).show();
            },

        },
        computed: {
            changeSelecteds() {
                varGame.child('timeSeconds').on('value', snap => this.selectTimeSeconds = snap.val());
                varGame.child('probability').on('value', snap => this.selectProbability = snap.val());
                varGame.child('passwordAdmin').on('value', snap => this.passwordAdmin = snap.val());
                varGame.child('linkEstadistiques').on('value', snap => this.linkEstadistiques = snap.val());
            }
        }
    }
</script>

<style scoped>


    .whiteText{
        color: white;
    }

</style>
